import { render, staticRenderFns } from "./RejectModal.vue?vue&type=template&id=17235c2b&scoped=true"
import script from "./RejectModal.vue?vue&type=script&lang=ts"
export * from "./RejectModal.vue?vue&type=script&lang=ts"
import style0 from "./RejectModal.vue?vue&type=style&index=0&id=17235c2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17235c2b",
  null
  
)

export default component.exports